import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { hasRelationship } from 'Helpers/Affordances';
import { noop } from 'Helpers/PropTypes';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';

const useStyles = buildUseStyles('RelationshipButton', () => ({
  root: {},
}));

const RelationshipButton = ({
  className,
  resource,
  relationship,
  onClick,
  children,
  test,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  // If relationship doesn't exist return nothing
  if (!hasRelationship(resource, relationship)) {
    return null;
  }

  return (
    <RoundedButton
      className={classNames(className, classes.root)}
      onClick={onClick}
      size={'sm'}
      padding={'dense'}
      color={'naturalGreen'}
      test={test}
    >
      {children}
    </RoundedButton>
  );
};

RelationshipButton.defaultProps = {
  className: '',
  onClick: noop,
  children: null,
  test: undefined,
};

RelationshipButton.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  relationship: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  test: PropTypes.string,
};

export default RelationshipButton;
